var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 9.33333H21.7773V5.33333C21.7773 4.97971 21.6368 4.64057 21.3867 4.39052C21.1367 4.14048 20.7975 4 20.4439 4H11.5559C11.2023 4 10.8632 4.14048 10.6131 4.39052C10.3631 4.64057 10.2226 4.97971 10.2226 5.33333V14.6667H2.66659C2.31296 14.6667 1.97382 14.8071 1.72378 15.0572C1.47373 15.3072 1.33325 15.6464 1.33325 16V26.6667C1.33325 27.0203 1.47373 27.3594 1.72378 27.6095C1.97382 27.8595 2.31296 28 2.66659 28H29.3333C29.6869 28 30.026 27.8595 30.2761 27.6095C30.5261 27.3594 30.6666 27.0203 30.6666 26.6667V10.6667C30.6666 10.313 30.5261 9.97391 30.2761 9.72386C30.026 9.47381 29.6869 9.33333 29.3333 9.33333ZM10.2226 25.3333H3.99992V17.3333H10.2226V25.3333ZM19.1106 25.3333H12.8893V6.66667H19.1106V25.3333ZM27.9999 25.3333H21.7773V12H27.9999V25.3333Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRank);
export default __webpack_public_path__ + "static/media/ic_rank.ac9ea2b273d63d7f2a240e6fbb0bd9fb.svg";
export { ForwardRef as ReactComponent };